import { MINIMUM_STRIPE_TX_AMOUNT, MIN_STRIPE_TX_AMT_AFTER_PROVIDER_FEE } from "@/constants";

/**
 * Stripe generate-payment-link expects the amount before the provider fee.
 * Displayed totalCost includes providerFee; the API adds the fee on top.
 * Totals at or below the all-in floor are charged at the $10 base (API adds ~5% fee).
 */
export const getStripePaymentLinkAmount = (totalCost: number, providerFee = 0) => {
  if (totalCost <= MINIMUM_STRIPE_TX_AMOUNT) {
    return MIN_STRIPE_TX_AMT_AFTER_PROVIDER_FEE;
  }

  return totalCost - providerFee;
};

/** True when card payment will be floor-charged to the $10 + 5% minimum. */
export const isStripeMinimumChargeApplied = (totalCost?: number) => {
  const amount = Number(totalCost);
  return Number.isFinite(amount) && amount > 0 && amount < MINIMUM_STRIPE_TX_AMOUNT;
};
